<template>

<v-content>
<v-container class="my-12">
  <div class="loading" v-if="loading">
    <div class="loader"></div>
</div>
<v-row>
      <v-col
        cols="12"
      >
  <v-card class="pa-4"  elevation="6" style="width:100%">
          <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
              <v-row>
                  <v-col cols="9"  md="9">
                    <v-tabs  background-color="transparent" dark v-model="tab">
                      <v-tab>ACA</v-tab>
                      <v-tab>FFA</v-tab>
                      <v-tab>ABM_807</v-tab>
                      <v-tab>IG1</v-tab>
                      <v-tab>IG2</v-tab>
                      <v-tab>IFIP</v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="3"  md="3">
                    <div>
                      <VueJsonToCsv :json-data="downloadCSV()" csv-title="NER_OpenNLP">
                        <v-btn small color="white" class="mx-1 float-right">
                          CSV <i class="mdi mdi-export-variant" aria-hidden="true"></i>
                        </v-btn>
                      </VueJsonToCsv>
                      <v-btn
                        small
                        @click="downloadJSON"
                        color="white"
                        class="mx-1 float-right"
                      >
                        JSON <i class="mdi mdi-export-variant" aria-hidden="true"></i>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card> 
          </v-card-title>

          <v-card-text >
              
      <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="item in items"
          :key="item.dataset.length"
      >
          <v-row mb-0>
          <v-col class="ml-3">
    <!--        <pre><p class="text-wrap">{{ result }}</p></pre> -->
            <p class="secondary--text font-weight-medium ma-0"  >
              Dataset: {{item.name}}
            </p> 
                      <p class="secondary--text font-weight-medium ma-0"  >
                                    <v-btn
              icon
              x-small
              color="#AD8744"
              @click.stop="updateDialog(item.uLocal,'Local entities')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
              Local: {{item.numLocal}}
            </p> 

            <p class="secondary--text font-weight-medium ma-0"  >
                          <v-btn
              icon
              x-small
              color="#AD8744"
              @click.stop="updateDialog(item.uOrganizacao,'Organização entities')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
               Organizacao: {{item.numOrg}}
            </p> 
            <p class="secondary--text font-weight-medium ma-0"  >
                          <v-btn
              icon
              x-small
              color="#AD8744"
              @click.stop="updateDialog(item.uData,'Data entities')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
               Data: {{item.numData}}
            </p> 
         
          </v-col>
          <v-col>
                        <p class="secondary--text font-weight-medium ma-0"  >
                          
              Entities Found: {{item.dataset.length}}
            </p> 

            <p class="secondary--text font-weight-medium ma-0"  >
                          <v-btn
              icon
              x-small
              color="#AD8744"
              @click.stop="updateDialog(item.uPessoa,'Pessoa entities')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
               Pessoa: {{item.numPessoa}}
            </p> 
            <p class="secondary--text font-weight-medium ma-0"  >
                          <v-btn
              icon
              x-small
              color="#AD8744"
              @click.stop="updateDialog(item.uProfissao,'Profissão/Título entities')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
               Profissão/Título: {{item.numProfissao}}
            </p> 
          </v-col>
          </v-row>


      <v-text-field

        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
        <v-data-table
      :headers="headers"
      :items="item.dataset"
      :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
      class="elevation-1"
      :search="search"
    >
    </v-data-table>
      </v-tab-item>
    </v-tabs-items>


          </v-card-text>
      </v-card>
      </v-col>
      </v-row>

    </v-container>
   <v-dialog
      v-model="dialog"
      persistent
      width="auto "
      scrollable
    >
 <v-card style=" margin-top:15px">
          <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -15px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
              <v-row>
                  <v-col cols="6"  md="6">
                    <h4 class="font-weight-light text-h5" style="color: #ffffff">
                      {{modalTitle}}
                    </h4>
                  </v-col>
                  <v-col cols="6"  md="6">
                    <div>
                      <VueJsonToCsv :json-data="downloadCSV2()" csv-title="NER_Results">
                        <v-btn small color="white" class="mx-1 float-right">
                          CSV <i class="mdi mdi-export-variant" aria-hidden="true"></i>
                        </v-btn>
                      </VueJsonToCsv>
                      <v-btn
                        small
                        @click="downloadJSON2"
                        color="white"
                        class="mx-1 float-right"
                      >
                        JSON <i class="mdi mdi-export-variant" aria-hidden="true"></i>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="headers"
              :items="itemsDialog"
              :sort-by="['entity']"
              :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
              class="elevation-1"
              :search="search2"
              :page.sync="page"
            >
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-content>


</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
const dataAPI = require("@/config/hosts").dataAPI;
import axios from 'axios'
var ACA_CONTENT = ""
var ABM_807 = ""
var FAA = ""
var IG = ""
var IFIP = ""
var INQUIROBS = ""
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: 'Home',
  components: {
    HelloWorld,
    VueJsonToCsv
  },
 data() {
    return {
    file: [],
    result: "",
    search:"",
    search2:"",
    text:"",
    page:1,
    numOrg: 0,
    numData: 0,
    numLocal: 0,
    numProfissao:0,
    numPessoa:0,
    faaItems:[],
    ABMItems:[],
    IFIPItems:[],
    IG1Items:[],
    modalTitle:"",
    itemsDialog:[],
    IG2Items:[],
    tab:"",
    loading:false,
    dialog:false,
    headers: [
          {
            text: 'Entity Label',
            align: 'start',
            sortable: true,
            value: 'label',
          },
          { text: 'Named Entity', value: 'entity' },
        ],
    items: [],
    }
  },
  created(){
    this.getData()
  },
  methods:{
     getData(){
      let URL1 = dataAPI + "results/spaCy/ACA_CONTENT"
      let URL2 = dataAPI + "results/spaCy/FAA"
      let URL3 = dataAPI + "results/spaCy/ABM_807"
      let URL4 = dataAPI + "results/spaCy/IG"
      let URL5 = dataAPI + "results/spaCy/INQUIROBS"
      let URL6 = dataAPI + "results/spaCy/IFIP"


      const promise1 = axios.get(URL1);
      const promise2 = axios.get(URL2);
      const promise3 = axios.get(URL3);
      const promise4 = axios.get(URL4);
      const promise5 = axios.get(URL5);
      const promise6 = axios.get(URL6);
      var self = this
      this.loading = true
      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6]).then(function(values) {
        console.log(values);
        ACA_CONTENT = values[0].data
        FAA = values[1].data
        ABM_807 = values[2].data
        IG = values[3].data
        INQUIROBS = values[4].data
        IFIP = values[5].data
        self.initData()
        self.loading = false
      })
      .catch(erro => self.loading = false)

    },
    initData(){
    this.items.push(this.initialize(ACA_CONTENT))
    this.items[this.items.length - 1].name="Arquivo da Casa Avelar"
    this.items.push(this.initialize(FAA))
    this.items[this.items.length - 1].name="Família Araújo de Azevedo"
    this.items.push(this.initialize(ABM_807))
    this.items[this.items.length - 1].name="Paróquia do Curral das Freiras"
    this.items.push(this.initialize(IG))
    this.items[this.items.length - 1].name="Inquirições de Genere 1"
    this.items.push(this.initialize(INQUIROBS))
    this.items[this.items.length - 1].name="Inquirições de Genere 2"
    this.items.push(this.initialize(IFIP))
    this.items[this.items.length - 1].name="International Federation for Information Processing"
    console.log(this.items)
    this.items.forEach(e => this.updateMetrics(e))
    console.log(this.items)
    },
    initialize(array){
      var v = {}
      v.dataset = array
      return v
    },
    downloadJSON: function(){
    if(this.items.length == 0){ alert("Empty Table!"); return;}
    const data = JSON.stringify(this.items)
    const blob = new Blob([data], {type: 'text/plain'})
    const e = document.createEvent('MouseEvents'),
    a = document.createElement('a');
    a.download = "NER_OpenNLP.json";
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
    },
    downloadCSV: function(){
        return this.items
    },
      downloadJSON2: function(){

          if(this.itemsDialog.length == 0){ alert("Empty Table!"); return;}
          const data = JSON.stringify(this.itemsDialog)
          const blob = new Blob([data], {type: 'text/plain'})
          const e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
          a.download = "NER_Results.json";
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
          e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
    },
    downloadCSV2: function(){
        return this.itemsDialog
    },
          filterUnique: function(array,entity){
        var entitiesArray = array.filter(e => e.label == entity)
        var entityArray = entitiesArray.map(e => e.entity);
        var uniqueArray=  [...new Set(entityArray)];
        var result = uniqueArray.map(item => ({ label: entity,entity:item }));
        return result;
        

      },
      updateMetrics: function(item){
                    var aux = 0;
          var aux2 = 0;
          var aux3 = 0;
          var aux4 = 0;
          var aux5 = 0;
          var dados = item.dataset
          dados.forEach(e => {
            if(e.label == "Organizacao")
            aux ++;
            else if(e.label == "Data")
            aux2 ++;
            else if (e.label == "Local")
            aux3 ++;
            else if(e.label == "Profissao")
            aux4 ++;
            else 
            aux5 ++;
          });
          item.numOrg = aux;
          item.numData = aux2;
          item.numLocal = aux3;
          item.numProfissao = aux4;
          item.numPessoa = aux5;
          item.uOrganizacao = this.filterUnique(dados,"Organizacao")
          item.uPessoa = this.filterUnique(dados,"Pessoa")
          item.uLocal = this.filterUnique(dados,"Local")
          item.uData = this.filterUnique(dados,"Data")
          item.uProfissao = this.filterUnique(dados,"Profissao")
      },
      updateDialog: function(entities,title){
        this.modalTitle=title
        this.page = 1
        this.itemsDialog = entities
        this.dialog=true
      }
  }
};
</script>



<style scoped>
.loading {
    position: fixed;
    top: 0; right: 0;
    bottom: 0; left: 0;

    filter: alpha(opacity=40);
    z-index:1000000;

     background-color:rgb(236, 234, 234,0.4);
    z-index:100;

}
.loader {
    left: 50%;
    margin-left: -4em;
    font-size: 10px;
    border: .8em solid rgba(218, 219, 223, 1);
    border-left: .8em solid #AD8744;
    animation: spin 1.1s infinite linear;
    z-index:10000;
    opacity: 1;
}
.loader, .loader:after {
    border-radius: 50%;
    width: 8em;
    height: 8em;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -4.05em;
    z-index:10000;
    opacity: 1;
}

@keyframes spin {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

</style>

